import { render, staticRenderFns } from "./DestinationCard.vue?vue&type=template&id=6b6c5aab&"
import script from "./DestinationCard.ts?vue&type=script&lang=ts&"
export * from "./DestinationCard.ts?vue&type=script&lang=ts&"
import style0 from "./DestinationCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports